import Highcharts from 'highcharts';
import { fCurrency } from '@utils/formatters';
import {
  DataItem,
  salesLiftChartColors,
} from '@components/Dashboard/SalesAttribution/SalesAttributionView/Summary/SalesLiftChart/salesLiftChart';

export const salesLiftChartOptions = (
  data: DataItem[],
  colors?: string[]
): Highcharts.Options => {
  if (!data[0]) {
    throw new Error('Data is empty');
  }

  return {
    chart: { type: 'column' },

    annotations: [
      {
        draggable: '',
        shapes: [
          {
            type: 'path',
            dashStyle: 'Dash',
            points: [
              {
                x: -0.4,
                xAxis: 0,
                y: data[0].sales,
                yAxis: 0,
              },
              {
                x: data.length + 0.4,
                xAxis: 0,
                y: data[0].sales,
                yAxis: 0,
              },
            ],
          },
        ],
      },
    ],

    title: {
      text: undefined,
    },

    credits: {
      enabled: false,
    },

    exporting: {
      buttons: {
        contextButton: {
          enabled: false,
        },
      },
    },

    xAxis: {
      type: 'category',
      visible: true,
      lineWidth: 1,
      labels: {
        style: {
          fontSize: '16px',
          color: 'black',
        },
      },
    },

    yAxis: {
      visible: false,
    },

    legend: {
      enabled: false,
    },

    tooltip: {
      enabled: false,
    },

    plotOptions: {
      series: {
        borderWidth: 0,
        enableMouseTracking: false,
      },
      column: {
        borderRadius: 5,
      },
    },

    series: [
      {
        type: 'column',
        colors: colors ?? salesLiftChartColors,
        colorByPoint: true,
        data: data.map(dataItem => ({
          name: dataItem.name,
          y: dataItem.sales,
        })),
        dataLabels: {
          enabled: true,
          formatter() {
            return fCurrency(this.y ?? 0);
          },
          style: {
            fontWeight: 'bold',
            fontSize: '16px',
            textOutline: 'none',
          },
          verticalAlign: 'top',
          color: 'black',
          y: -30,
        },
        pointPadding: 0,
        groupPadding: 0.1,
      },
    ],
  };
};
